export default "__VITE_ASSET__e1306422__"